import React from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Clock } from "lucide-react";
import AuthShell from "@/components/AuthShell";

/** Shown after a business application is submitted. */
export const PendingApprovalCard = ({ name, email, onHome, onLogin }) => (
  <AuthShell heading="Application received." footerTag="valuepool.app / v1">
    <Card className="max-w-md w-full p-8 border border-border bg-card text-center" data-testid="pending-approval-card">
      <div className="w-16 h-16 rounded-2xl bg-secondary/15 text-secondary mx-auto grid place-items-center">
        <Clock className="w-8 h-8" />
      </div>
      <h1 className="font-heading text-2xl font-semibold mt-4">Thanks {name}</h1>
      <p className="text-muted-foreground mt-2 text-sm">
        Your partner application is under review.
        {email ? <> We've sent a confirmation to <b className="text-foreground">{email}</b>.</> : null}
        {" "}Once approved, you can log in with your phone OTP or password.
      </p>
      <div className="mt-6 flex flex-col gap-2">
        <Button onClick={onHome} className="bg-primary text-primary-foreground" data-testid="pending-home-btn">Back to home</Button>
        <Button variant="outline" onClick={onLogin} data-testid="pending-login-btn">Go to login</Button>
      </div>
    </Card>
  </AuthShell>
);

export default PendingApprovalCard;
